<template>
  <component
    :is="component"
    v-bind="mergedAttrs"
    v-on="$listeners"
  >
    <template
      v-for="(_, slotName) in $scopedSlots"
      #[slotName]="slotProps"
    >
      <slot
        :name="slotName"
        v-bind="slotProps"
      />
    </template>

    <slot />
  </component>
</template>

<script>
export default {
  name: 'BaseWrapper',

  inheritAttrs: false,

  props: {
    /**
     * Vuetify component name (v-text-field, v-treeview, ...etc.)
     */
    component: {
      type: null,
      required: true,
      default: () => ({})
    }
  },

  computed: {
    mergedAttrs () {
      return {
        ...this.$props,
        ...this.$attrs
      }
    }
  }
}
</script>
